import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaWhatsapp, FaEnvelope, FaPhone, FaTruck } from 'react-icons/fa';
import './Header.css';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    return (
        <>
            <div className="top-bar">
                <div className="container">
                    <div className="top-bar-content">
                        <div className="contact-info">
                            <span><FaEnvelope /> info@bkpackersandmovers.in</span>
                            <span>Sri Periyandavar Thunai</span>
                        </div>
                        <div className="phone-info">
                            <FaPhone /> 81899 99775
                        </div>
                    </div>
                </div>
            </div>

            <header className="header">
                <div className="container">
                    <div className="header-content">
                        <div className="logo">
                            <div className="logo-icon">
                                <img src="/Images/logo.png" alt="BK Packers & Movers" loading="eager" style={{ width: '180px', height: 'auto' }} />
                            </div>
                        </div>

                        <nav className={`nav ${isMenuOpen ? 'active' : ''}`}>
                            <Link to="/" onClick={() => setIsMenuOpen(false)}>Home</Link>
                            <Link to="/about" onClick={() => setIsMenuOpen(false)}>About Us</Link>
                            <Link to="/services" onClick={() => setIsMenuOpen(false)}>Services</Link>
                            <Link to="/testimonials" onClick={() => setIsMenuOpen(false)}>Testimonials</Link>
                            <a href="https://wa.me/918189999775" target="_blank" rel="noopener noreferrer" onClick={() => setIsMenuOpen(false)}>Contact Us</a>
                        </nav>

                        <div className="whatsapp-icon">
                            <a href="https://wa.me/918189999775" target="_blank" rel="noopener noreferrer">
                                <FaWhatsapp />
                            </a>
                        </div>

                        <div className="menu-toggle" onClick={() => setIsMenuOpen(!isMenuOpen)}>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                </div>
            </header>
        </>
    );
};

export default Header;

